var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.16667C0 0.521354 0.510714 0 1.14286 0H14.8571C15.4893 0 16 0.521354 16 1.16667C16 1.81198 15.4893 2.33333 14.8571 2.33333H1.14286C0.510714 2.33333 0 1.81198 0 1.16667ZM0 7C0 6.35469 0.510714 5.83333 1.14286 5.83333H10.2857C10.9179 5.83333 11.4286 6.35469 11.4286 7C11.4286 7.64531 10.9179 8.16667 10.2857 8.16667H1.14286C0.510714 8.16667 0 7.64531 0 7ZM6.85714 12.8333C6.85714 13.4786 6.34643 14 5.71429 14H1.14286C0.510714 14 0 13.4786 0 12.8333C0 12.188 0.510714 11.6667 1.14286 11.6667H5.71429C6.34643 11.6667 6.85714 12.188 6.85714 12.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.e9c0bb6a57a8b3e11f681537bbe14c61.svg";
export { ForwardRef as ReactComponent };